/**
 * The savings plans a fund can be, as the backend numbers them.
 *
 * The list itself is fetched — see `useInvestmentPlanTypes` — because it is
 * the backend's to extend. These ids exist only for the one rule the form has
 * to know without asking: Habit Save is the plan with withdrawal windows.
 *
 * `Enums.InvestmentTypes` on the request as `productTypeId`. Mobile hides any
 * product that has none, so it is not optional in practice however the DTO
 * declares it.
 *
 * The API owner says he sets this himself; the source does not support that
 * (`CreateInvestmentProductCommandHandler.cs:113` stores the request value
 * verbatim and nothing infers it), so it is sent from here behind one flag
 * while the question is open. See Q1 in docs/ADMIN_BACKEND_QUESTIONS.md.
 */
export const PlanType = {
  FixedDeposit: 1,
  GoalSave: 2,
  Flexisave: 3,
  HabitSave: 4,
} as const;

export type TPlanTypeId = (typeof PlanType)[keyof typeof PlanType];

export const SEND_PRODUCT_TYPE_ID = true;

/** Only Habit Save carries withdrawal windows. */
export function needsWithdrawalWindows(
  planTypeId: number | null | undefined,
): boolean {
  return Number(planTypeId) === PlanType.HabitSave;
}
